export const YOUNG_ADULT_PROMOTION_NAME = 'TSA PreCheck® $20 Take Off'
export const YOUNG_ADULT_PROMOTION_URL_FRAGMENT = 'take-off-promo'
export const YOUNG_ADULT_PROMOTION_PATH = `/help#${YOUNG_ADULT_PROMOTION_URL_FRAGMENT}`
export const TSA_PRECHECK_BRAND = 'TSA PreCheck®'
